import { Vector3 } from '@babylonjs/core/Maths/math.vector';

const checkVector3 = (obj: any): Object | Vector3 => {
    if (obj && (obj.x !== undefined || obj.y !== undefined || obj.z !== undefined)) {
        return new Vector3(obj.x || 0, obj.y || 0, obj.z || 0);
    }
    return obj;
};

export const limitAccuracy = (number: number, length: number): number => {
    if (length === 1) return Math.round(number);
    const powLength = 10 ** length;
    return Math.round(number * powLength) / powLength;
};

export class JsonHelper {
    public recursiveJsonToObject(interfaceObject: Object, objectToTransale: Object): Object {
        const param: any = {};
        const keys = Object.keys(interfaceObject);
        keys.forEach((key) => {
            const par = interfaceObject[key];
            let trad = par.dim;
            if (!trad) trad = par;
            if (objectToTransale[trad] !== undefined) {
                if (par.next !== undefined) {
                    // If this need to translate an array
                    if (par.next.constructor === Array) {
                        param[key] = [];
                        objectToTransale[trad].forEach((iterator) => {
                            param[key].push(this.recursiveJsonToObject(par.next[0], iterator));
                        });
                    } else {
                        const obj = this.recursiveJsonToObject(par.next, objectToTransale[trad]);
                        param[key] = checkVector3(obj);
                    }
                } else {
                    param[key] = checkVector3(objectToTransale[trad]);
                }
            }
        });
        return param;
    }

    public recursiveObjectToJson(interfaceObject: Object, objectToTransale: Object): Object {
        const json = {};
        const keys = Object.keys(interfaceObject);
        keys.forEach((key) => {
            if (objectToTransale[key] !== undefined) {
                const par = interfaceObject[key];
                if (par.next !== undefined) {
                    if (par.next.constructor === Array) {
                        json[par.dim] = [];
                        objectToTransale[key].forEach((iterator) => {
                            json[par.dim].push(this.recursiveObjectToJson(par.next[0], iterator));
                        });
                    } else {
                        json[par.dim] = this.recursiveObjectToJson(par.next, objectToTransale[key]);
                    }
                } else if (par.accuracy !== undefined) {
                    json[par.dim] = limitAccuracy(objectToTransale[key], par.accuracy);
                } else {
                    json[par] = objectToTransale[key];
                }
            }
        });
        return json;
    }

    public recursiveObjectToObject(interfaceObject: Object, objectToTransale: Object): Object {
        const json = {};
        const keys = Object.keys(interfaceObject);
        keys.forEach((key) => {
            if (objectToTransale[key] !== undefined) {
                const par = interfaceObject[key];
                if (par.next !== undefined) {
                    json[key] = this.recursiveObjectToObject(par.next, objectToTransale[key]);
                } else if (par.accuracy !== undefined) {
                    json[key] = limitAccuracy(objectToTransale[key], par.accuracy);
                } else {
                    json[key] = objectToTransale[key];
                }
            }
        });
        return json;
    }
}
